import { ANALYTICS_EVENTS, track } from './analytics'
import { debounce, isElementInViewport } from './utils'
import VideoControls from './video-controls'

class Gallery {
  constructor() {
    this.galleryOpen = false
    this.prevPhotoIndexes = []
    this.prevVideoIndexes = []
    new VideoControls()

    this.initializeGallery()
  }

  stopVideo(element) {
    var iframes = document.querySelectorAll(element + ' iframe')
    for (const iframe of iframes) {
      var iframeSrc = iframe.src
      iframe.src = iframeSrc
    }
  }

  closeGallery() {
    document.body.classList.remove('is-gallery-modal-open')
    this.galleryOpen = false
    this.prevPhotoIndexes = []
    this.prevVideoIndexes = []
    this.stopVideo('.gallery-modal')
  }

  initializeGallery() {
    var $this = this

    const listingId = document
      .querySelector('.main-wrapper')
      .getAttribute('data-listing-id')

    const $photos = $('.gallery-modal .img-wrapper')
    const $videos = $('.gallery-modal .video-wrapper')

    // Handles tracking photo/video analytics in current viewport
    function trackPhotoVideoAnalytics() {
      if (!$this.galleryOpen) return

      const photoIndexes = []
      const videoIndexes = []

      $photos.forEach(($el, index) => {
        if (
          isElementInViewport($el) &&
          !$this.prevPhotoIndexes.includes(index)
        ) {
          photoIndexes.push(index)
          track(ANALYTICS_EVENTS.PHOTO_VIEW, { ListingId: listingId })
        }
      })

      $videos.forEach(($el, index) => {
        if (
          isElementInViewport($el) &&
          !$this.prevPhotoIndexes.includes(index)
        ) {
          videoIndexes.push(index)
          track(ANALYTICS_EVENTS.VIDEO_VIEW, { ListingId: listingId })
        }
      })

      if (photoIndexes.length) {
        $this.prevPhotoIndexes.splice(
          0,
          $this.prevPhotoIndexes.length,
          ...photoIndexes
        )
      }
      if (videoIndexes.length) {
        $this.prevVideoIndexes.splice(
          0,
          $this.prevVideoIndexes.length,
          ...videoIndexes
        )
      }
    }

    // Listen for the event.
    window.addEventListener(
      'back-to-default',
      function (e) {
        $this.closeGallery()
      },
      false
    )

    // modal cta
    var $modalCTA = document.querySelectorAll('.gallery-cta')
    for (const cta of $modalCTA) {
      cta.addEventListener('click', function (event) {
        event.preventDefault()
        document.body.classList.toggle('is-gallery-modal-open')
        setTimeout(function () {
          $this.galleryOpen = !$this.galleryOpen

          // Track analytics when the gallery modal opens
          if ($this.galleryOpen) {
            trackPhotoVideoAnalytics()
          }
        }, 400)
      })
    }

    // modal close cta
    var $modalClose = document.querySelector('.gallery-modal .close-modal-cta')
    $modalClose.addEventListener('click', function (event) {
      event.preventDefault()
      $this.closeGallery()
      return false
    })

    // Track analytics on scroll
    $('.gallery-modal').on('scroll', debounce(trackPhotoVideoAnalytics, 150))
  }
}

export default Gallery

// const loadJS = (source, callback) => {
//   // Fn to load JS files and append to <head></head>
//   let scriptEl = document.createElement('script'),
//     head = document.getElementsByTagName('head')[0]
//   scriptEl.async = 1
//   scriptEl.defer = 1
//   scriptEl.onload = scriptEl.onreadystatechange = function (_, isAbort) {
//     if (
//       isAbort ||
//       !scriptEl.readyState ||
//       /loaded|complete/.test(scriptEl.readyState)
//     ) {
//       scriptEl.onload = scriptEl.onreadystatechange = null
//       scriptEl = undefined
//       if (!isAbort) {
//         if (callback) callback()
//       }
//     }
//   }
//   scriptEl.src = source
//   head.appendChild(scriptEl)
// }

// // OPTIONAL -- a video is inserted to DOM after 2 seconds
// setTimeout(() => {
//   let dynamicEl = document.querySelector('.dynamic-item')
//   dynamicEl.innerHTML =
//     '<h4>YouTube Video -- Dynamically inserted to DOM</h4><iframe width="560" height="315" src="https://www.youtube.com/embed/RK1K2bCg4J8?rel=0&amp;controls=0&amp;showinfo=0&amp;enablejsapi=1" frameborder="0" allowfullscreen></iframe>'
//   iframeVideoPlugin.init() // re-initilized because a new video is intered to page
// }, 2000)
